import React, { useCallback } from 'react';
import './Status.scss';
import ExpectedDelivery from './ExpectedDelivery';
import { formatDate } from '../../utils/helper';
import LinkProvider from '../LinkProvider/LinkProvider';

function Status(props) {
  const {
    view,
    delivered,
    deliveryDate,
    revisedEta,
    arrivedEarlyText,
    status: { status: statusAlias, createdAt, statusLabel, iconUrl, courierTrackingUrl } = {},
    dataLocale,
    listing,
    localeInfo,
    orderId,
    itemId,
    itemTracking,
    orderData,
  } = props;
  const { TRACKING_STATUS_ICON_ALT, VIEW_RETURN_REFUND_DETAILS } = dataLocale;
  const createdAtDate =
    createdAt && ['DELIVERED_AT_STORE', 'DELIVERED_TO_CUSTOMER'].includes(statusAlias)
      ? formatDate(createdAt, 'EEE, D MMM')
      : '';
  const statusIcon =
    iconUrl || 'https://static.lenskart.com/media/mobile/universal/assets/default-status-icon.svg';
  const clickHandlerFn = useCallback(() => {
    const trackEnv = view === 'desktop' ? 'dtm' : 'mobileGA';
    if (window[trackEnv].LenskartRewamp) {
      window[trackEnv].LenskartRewamp.myaccount?.myOrderStatusEventsClick(listing, 'track courier');
    }
  }, []);
  let showReturnDetails = false;
  let current = false;
  for (let i = 0, len = itemTracking?.histories?.length; i < len; i++) {
    const history = itemTracking?.histories[i];
    if (history?.showReturnDetails && history?.current) {
      showReturnDetails = history.showReturnDetails;
      current = history.current;
    }
  }
  return (
    <React.Fragment>
      <div
        className={`pos-rel item-status ${
          view === 'desktop'
            ? 'padding-t15 padding-b15 padding-r12 padding-l45 margin-l20 margin-r20'
            : 'pd-t12 pd-b12 pd-r12 pd-l50'
        }`}
        data-testid="statusWrapper"
      >
        <span className={`img-icon ${view === 'desktop' ? 'desktop' : 'mobile'} pos-abs`}>
          <img alt={TRACKING_STATUS_ICON_ALT} aria-label="Tracking Status Icon" src={statusIcon} />
        </span>
        <div className="status-date-wrapper display-flex align-items-center">
          <span className="flex-1 status-label fs14 fsp14">
            {localeInfo?.countryCode !== 'sg' && deliveryDate && (
              <div className={`status-date ${view === 'desktop' ? 'fs16 font-bold' : 'fw900'}`}>
                <ExpectedDelivery
                  dataLocale={dataLocale}
                  deliveryDate={deliveryDate}
                  revisedEta={revisedEta}
                />
              </div>
            )}
            {!deliveryDate ? (
              <div
                className={`${view === 'desktop' ? 'fs16 font-bold' : 'fw900'}`}
                data-testid="deliveredLabel"
              >
                <div>
                  {statusLabel} {arrivedEarlyText} {createdAtDate}
                </div>
                {view !== 'desktop' && showReturnDetails && current && (
                  <LinkProvider
                    className="text-color_link_blue fw400 block"
                    to={`/sales/order/return-details/${orderId}/${itemId}`}
                  >
                    {VIEW_RETURN_REFUND_DETAILS}
                  </LinkProvider>
                )}
              </div>
            ) : (
              <span className={`${view === 'desktop' ? 'fw700' : 'fw500'}`}>{statusLabel}</span>
            )}
          </span>
          {courierTrackingUrl &&
            courierTrackingUrl !== 'NA' &&
            !delivered &&
            !orderData?.isInsuranceFlow && (
              <div className="text-right text-uppercase align-self-start mr-l10">
                <a
                  className={`track-btn no-decoration inline-block text-center ${
                    view === 'desktop'
                      ? 'padding-t10 padding-b10 padding-l20 padding-r20 fs14'
                      : 'pd-8 fsp-12 fw700'
                  }`}
                  href={courierTrackingUrl}
                  rel="noopener noreferrer"
                  target="_blank"
                  onClick={clickHandlerFn}
                >
                  {dataLocale.TRACK_COURIER}
                </a>
              </div>
            )}
        </div>
      </div>
    </React.Fragment>
  );
}
export default Status;
